import React, { useEffect } from "react";
import AppRoutes from "./routes";
import { Provider } from "react-redux";
import store from "./redux/store";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "assets/styles/index.scss";
import Cookies from "js-cookie";

const App = () => {
  useEffect(() => {
    Cookies.remove("username", { path: "" });
  }, []);

  return (
    <Provider store={store}>
      <AppRoutes />
      <ToastContainer />
    </Provider>
  );
};

export default App;
